export default __webpack_public_path__ + "static/checkpoint-fdf768d7ba2c76e1861d025d8086059f.png";